
import "./reset.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";

/* formulário */
import { useForm } from "react-hook-form";

/* funções auxiliares */
import { clearError, showError, registerLog } from "../../services/functions/functions.ts";

/* banco de dados */
import { auth } from "../../services/firebaseConnection";
import { sendPasswordResetEmail, verifyPasswordResetCode  } from "firebase/auth";


export default function Reset() {

    const [step, setStep] = useState(0);
    const [error, setError] = useState("0");
    const [load, setLoad] = useState(false);

    /* refs para tratamento de erros */
    const refEmail = useRef(null);
    const refErrorEmail = useRef(null);
    const refLabelEmail = useRef(null);
    
    const { handleSubmit, register, getValues } = useForm();


    useEffect(() => {
    
        const query = new URLSearchParams(window.location.search);
        const code = query.get("oobCode");

        if(code) {
            verifyPasswordResetCode(auth, code).then(() => {
                setStep(2);
            })
            .catch(() => {
                setError("Link inválido ou expirado.");
            });
        }
    
    }, []);



    async function passo1(data) {

        const v_email = (email) => { let validate = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; return validate.test(email); }

        let ma = getValues("email");
        if(!v_email(ma)) {
            showError(refEmail, refLabelEmail, refErrorEmail, "Esse email é inválido, verifique a digitação", setError, "email");
            return;
        }

        try {

            setLoad(true);
        
            await sendPasswordResetEmail(auth, ma, {url: "https://winners-ai.com/reset"});
        
            registerLog(-1, "/reset_senha_step1/email=" + ma);
            setStep(1);

            setLoad(false);

        }
        catch(erro) {
            console.log("tratar o erro");
        }

    }


    async function passo3(data) {

        
        setStep(3);

    }


    return(
        <div className="context">

            <Header access={0}></Header>

            <div className="content">
                <div className="ft_topico">Esqueci minha senha</div>
                <div className="ft_descricao">Vamos resetar sua senha, para isso, precisamos validar seu email.</div>
                <div className="space"></div>

                <div className="border_form reset_border_form">
                    
                    { step === 0 && (
                    <>
                    <form className="form" onSubmit={handleSubmit(passo1)}>
                        <span className="step_form">
                            <span className="step_form_number">Passo 1/3</span>
                            <span className="step_form_description">&nbsp;. Email</span>
                        </span>
                        <span className="space_form"></span>

                        <span className="title_form">Alterar a senha</span>
                        <span className="subtitle_form">Siga corretamente oa passos abaixo para trocar sua senha.</span>
                        <span className="space_form"></span>

                        <span ref={refErrorEmail} className="error_form"></span>
                        <label for="inp" className="inp" ref={refLabelEmail}>
                        <input type="text" placeholder="&nbsp;" maxLength={60} {...register("email")} ref={(el) => {refEmail.current = el; register("email").ref(el);}} onClick={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)} onChange={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)}></input>
                        <span className="label">Digite seu email</span>
                        <span className="focus-bg"></span>
                        </label>
                        <span className="space_form"></span>

                        <button type="submit" name="bt1" className={load ? "button_disabled_form" : "button_form"} disabled={load}>{load ? "AGUARDE ..." : "AVANÇAR"}</button>
                    </form>
                    </>
                    )}

                    { step === 1 && (
                    <>
                    <form className="form">
                        <span className="step_form">
                            <span className="step_form_number">Passo 2/3</span>
                            <span className="step_form_description">&nbsp;. Verifique seu email</span>
                        </span>

                        <span className="space_form"></span>

                        <span>Enviamos um link para redefinir sua senha.</span>
                        <span>Acesse sua caixa de entrada e clique no link para continuar.</span>
                        <span>Caso não encontre, verifique a pasta de spam.</span>
                    </form>
                    </>
                    )}



                    { step === 2 && (
                    <>
                    <form className="form" onSubmit={handleSubmit(passo3)}>
                        <span className="step_form">
                            <span className="step_form_number">Passo 3/3</span>
                            <span className="step_form_description">&nbsp;. Definir a senha</span>
                        </span>
                        <span className="space_form"></span>
                    
                        <span ref={refErrorEmail} className="error_form"></span>
                        <label for="inp" className="inp" ref={refLabelEmail}>
                        <input type="password" placeholder="&nbsp;" maxLength={12} {...register("senha")} ref={(el) => {refEmail.current = el; register("senha").ref(el);}} onClick={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)} onChange={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)}></input>
                        <span className="label">Digite seu senha</span>
                        <span className="focus-bg"></span>
                        </label>
                        <span className="space_form"></span>

                        <button type="submit" name="bt1" className="button_form">{"AVANÇAR"}</button>
                    </form>
                    </>
                    )}


                    { step === 3 && (
                    <>
                    
                    <div>****** TELA DE SUCESSO</div>
                    
                    </>
                    )}
                    
                </div>
                
                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>

            </div>

            <Footer access={0}></Footer>

        </div>
    )
}